import React, { useState, useRef } from "react";
import Axios from 'axios';
import { useNavigate, Link } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";

function Login(props) {
  const emailRef = useRef(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  let navigate = useNavigate();

  const isEmail = (email) =>
    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

  const login = (e) => {
    e.preventDefault();
    const errs = {};

    if (!isEmail(username)) {
      emailRef.current.focus();
      errs.email = "Enter a valid email.";
      setErrors(errs);
      return;
    }

    setErrors({});

    Axios.post("https://mygamename.com/php/login.php", {
      username,
      password,
    }).then((response) => {
      if (response.data.message) {
        setErrors({ email: response.data.message });
      } else {
        // Handle array format [{email, token}] or raw JWT string
        let email, token;
        if (Array.isArray(response.data)) {
          email = response.data[0].email;
          token = response.data[0].token;
        } else if (typeof response.data === 'string') {
          const candidate = response.data.trim();
          // Only treat as JWT if it has 3 dot-separated base64url segments
          if (/^[\w-]+\.[\w-]+\.[\w-]+$/.test(candidate)) {
            token = candidate;
            try {
              const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
              email = payload.email;
            } catch {}
          }
        }
        if (token) {
          localStorage.setItem('token', token);
          props.setLoginStatus(true);
          props.setUEmail(email);
          setUsername('');
          setPassword('');
          navigate('/create');
        } else {
          setErrors({ email: 'Login failed. Please try again.' });
        }
      }
    });
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-[#1a1a1a] border border-[#222222] rounded-xl p-8">
        <h1 className="text-3xl font-extrabold text-[#F5F5F5] mb-2 tracking-tight">Sign in</h1>
        <p className="text-[#F5F5F5]/50 text-sm mb-8">Welcome back. Enter your credentials to continue.</p>

        <form onSubmit={login} className="flex flex-col gap-4">
          <div>
            <input
              ref={emailRef}
              type="text"
              placeholder="Email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="bg-[#111111] border border-[#333333] text-[#F5F5F5] text-sm rounded-lg focus:ring-[#8B5CF6] focus:border-[#8B5CF6] block w-full p-3 placeholder-[#F5F5F5]/30 outline-none transition-colors"
            />
          </div>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-[#111111] border border-[#333333] text-[#F5F5F5] text-sm rounded-lg focus:ring-[#8B5CF6] focus:border-[#8B5CF6] block w-full p-3 pr-10 placeholder-[#F5F5F5]/30 outline-none transition-colors"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F5F5F5]/30 hover:text-[#F5F5F5]/70 transition-colors"
            >
              {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>

          {Object.entries(errors).map(([key, error]) => (
            <span key={key} className="text-red-400 text-xs font-semibold">{error}</span>
          ))}

          <div className="flex justify-end">
            <Link to="/password-reset" className="text-[#8B5CF6] text-xs hover:text-[#7C3AED] transition-colors">
              Forgot password?
            </Link>
          </div>

          <button
            type="submit"
            className="w-full bg-[#8B5CF6] hover:bg-[#7C3AED] text-[#F5F5F5] font-semibold py-3 rounded-lg transition-colors mt-2"
          >
            Sign In
          </button>
        </form>

        <p className="text-center text-[#F5F5F5]/50 text-sm mt-6">
          Don't have an account?{' '}
          <Link to="/signup" className="text-[#8B5CF6] hover:text-[#7C3AED] font-semibold transition-colors">
            Sign up
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
